import { useEffect, useRef } from 'react';

export default function usePreviousRef<T>(val: T) {
  const ref = useRef(val);
  useEffect(() => {
    ref.current = val;
  });

  return ref;
}
